import { appVersion } from './app-version';
import { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  languageSelection: false,
  env: 'local',
  version: appVersion,
  apiUrl: 'https://api-integration.viessmann-climatesolutions.com/',
  legalAppId: '4dd6e0d9-5626-4489-a802-460ae79bae6e',
  earlyAccess: 'https://forms.gle/eBFsSPjU23A65RoK6',
  accountUrl:
    'https://account-integration.viessmann-climatesolutions.com/personal-data?redirect=https://app.developer-integration.viessmann-climatesolutions.com&originApp=Developer Portal',
  appUrl: 'https://app.developer-integration.viessmann-climatesolutions.com',
  hiddenRedirectUris: [
    'https://app.developer-integration.viessmann-climatesolutions.com',
    'https://app.developer-staging.viessmann-climatesolutions.com',
    'https://app.developer.viessmann-climatesolutions.com',
  ],
  app: {
    defaultLanguage: 'en',
    supportedLanguages: [
      { locale: 'de', flag: 'de' },
      { locale: 'en', flag: 'en' },
    ],
  },
  auth: {
    appId: 'developer-portal',
    baseUrl: 'https://api-integration.viessmann-climatesolutions.com',
    registerBaseUrl:
      'https://account-integration.viessmann-climatesolutions.com',
    iamUrl: 'https://iaml3.viessmann-climatesolutions.com',
  },
  http: {
    translationBaseUrl:
      'https://api-integration.viessmann-climatesolutions.com/translations/v2/',
    usersBaseUrl:
      'https://api-integration.viessmann-climatesolutions.com/users/v1/',
    legal: 'https://api-integration.viessmann-climatesolutions.com/legal/v3/',
    purchases:
      'https://api-integration.viessmann-climatesolutions.com/purchases/v1/',
    clients:
      'https://api-integration.viessmann-climatesolutions.com/auth/v1/clients/',
    documentation:
      'https://api-integration.viessmann-climatesolutions.com/documentation',
    statusPage:
      'https://api-integration.viessmann-climatesolutions.com/status/v1/apps/r80xp4hm40b8/summary',
  },
  globalHeader: {
    baseUrl: 'https://api-integration.viessmann-climatesolutions.com',
    accountAppUrl: 'https://account-integration.viessmann-climatesolutions.com',
  },
};
